import { IAdminEventAwardsStore } from '../eventAwards/store';

export const adminRoundAwardsStore: IAdminEventAwardsStore = {};
